import React from 'react';
import { T, fontBody, selectStyle } from '../tokens';
import ToggleRow from '../ToggleRow';
import { LEAD_STAGE_OPTIONS } from '../validation/templateValidation';

export default function LeadStagePanel({
  templateType,
  settings,
  onSettingsChange,
  compact = false,
}) {
  if (!settings) return null;

  const isComment = templateType === 'comment_reply';
  const isDm = templateType === 'dm_reply';

  if (!isComment && !isDm) {
    return (
      <p style={{ fontFamily: fontBody, fontSize: 12, color: T.slateLight, margin: 0 }}>
        Lead creation runs on the comment reply and incoming DM templates — not on the follow-up DM step.
      </p>
    );
  }

  const enabledKey = isComment ? 'createLeadOnComment' : 'createLeadOnDm';
  const stageKey = isComment ? 'leadStageOnComment' : 'leadStageOnDm';
  const channelLabel = isComment ? 'comment auto-reply' : 'DM auto-reply';

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: compact ? 10 : 14 }}>
      <ToggleRow
        label={`Create CRM lead on ${channelLabel}`}
        checked={!!settings[enabledKey]}
        onChange={(on) => onSettingsChange({ [enabledKey]: on })}
      />
      {settings[enabledKey] && (
        <div>
          <div style={{ fontFamily: fontBody, fontSize: 12, fontWeight: 600, color: T.slate, marginBottom: 6 }}>
            Lead pipeline stage
          </div>
          <select
            style={selectStyle}
            value={settings[stageKey] || 'new'}
            onChange={(e) => onSettingsChange({ [stageKey]: e.target.value })}
          >
            {LEAD_STAGE_OPTIONS.map((opt) => (
              <option key={opt.value} value={opt.value}>{opt.label}</option>
            ))}
          </select>
          <p style={{ fontFamily: fontBody, fontSize: 11, color: T.slateLight, marginTop: 8, marginBottom: 0 }}>
            New leads from this flow are created at this stage.
          </p>
        </div>
      )}
    </div>
  );
}
